import axios from 'axios';

const handle401Error = (err) => {
    if(err.response && err.response.status === 401){
        // The JWT lives in an httpOnly cookie, so only clear the non-sensitive UI markers.
        localStorage.removeItem('userId');
        localStorage.removeItem('admin');
        localStorage.removeItem('token');
        window.location.href = '/login';
    }
};

const apiClient = axios.create({
    baseURL : process.env.REACT_APP_BASE_API_URL,
    // Send and receive cookies (httpOnly token cookie) automatically on every request.
    withCredentials: true,
    headers: {
        "Accept": "application/json",
        "Content-type": "application/json"
    }
});

// NOTE: With cookie-based auth there is no Authorization header.
// The browser sends the httpOnly "token" cookie automatically because of `withCredentials: true`.

export const get = async(url, headers = {}) => {
    try{
        return await apiClient.get(url, { headers })
    }catch(err){
        console.log(err);
        handle401Error(err);
        throw err;
    }
}

export const post = async(url, body, headers = {}) => {
    // Remove Content-Type header for FormData to let browser set it automatically
    if (body instanceof FormData) {
        delete headers['Content-Type'];
    }

    try{
        return await apiClient.post(url, body, { headers });
    }catch(err){
        console.log(err);
        handle401Error(err);
        throw err;
    }
}

export const put = async(url, body, headers = {}) => {
    // Remove Content-Type header for FormData to let browser set it automatically
    if (body instanceof FormData) {
        delete headers['Content-Type'];
    }

    try{
        return await apiClient.put(url, body, {headers})
    }catch(err){
        console.log(err);
        handle401Error(err);
        throw err;
    }
}

export const del = async(url, headers = {}) => {
    try{
        return await apiClient.delete(url, { headers })
    }catch(err){
        console.log(err);
        handle401Error(err);
        throw err;
    }
}